
import { VuexModule, Module, Mutation, Action } from 'vuex-module-decorators';
import Client from '@/extend/classes/Client';
import { storeSession } from '@/generated/stores';
import HubServices from "@/generated/hub/HubServices";
import ListData, { ListItem, ColumnConfig, ListConfig, ListFilter } from '@/extend/classes/ListData';
import { Alerts } from '@/framework/base/helpers/Alerts';

import { v4 as uuidv4 } from 'uuid';


@Module({ name: 'storeClient' })

export default class storeClient extends VuexModule {
  // States
  private reccords: Client[] = [];
  private config : ColumnConfig[] = [];
  private idsLoading: number[] = [];
  private dataLoading = false;
  private dataLoaded = false;
  private dataRegistered = false;

  // Getters on states for asynchronous actions
  private get clientLoading (): boolean {
    return this.dataLoading;
  }
  private get clientRegistered (): boolean {
    return this.dataRegistered;
  }

  
  public get clientLoaded (): boolean {
    return this.dataLoaded;
  }

  public get createNewClient() {
    return (): Client => { 
      return this.getClient(0, true);
    }
  }

  
  public get getClient () {
    return (id: number, canCreate = false): Client => {
      if (id == 0 && !canCreate) {
        Alerts.debug("Id Client can't be 0")
        return new Client();
      }
      const res = this.reccords.find(c => c.id == id);
      if (res != undefined) {
        return res;
      } else {
        const copy = new Client();
        if (id == 0) {
          if (this.reccords.length == 0) {
            copy.id = -1;
          } else {
            this.reccords.sort((a, b) => (a.id - b.id));
            copy.id = Math.min(-1, this.reccords[0].id - 1);
          }          copy.canDelete = true;          copy.canUpdate = true;
          copy.createId = uuidv4();
          this.reccords.push(copy);
        } else if (id > 0) {
          copy.id = id;
          this.reccords.push(copy);
          if (storeSession.httpCx != undefined && !this.idsLoading.includes(id)) {
            this.idsLoading.push(id);
            Client.getForStore(id).then((data: ListData) => {
              const tmpCopy = this.reccords.find(a => a.id == id);
              if (tmpCopy) {
                tmpCopy.fromClient(data.reccords[0] as Client);
              }
              const config = data.config as ListConfig
              if (this.config.length == 0) {
                config.columnsConfig.forEach((column) => {
                  this.config.push(column);
                })
              } else {
                config.columnsConfig.forEach((column) => {
                  if (column.choix.length == 1) {
                    const columnConfig = this.config.find(a => a.name == column.name);
                    if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
                      const columnChoix = columnConfig.choix;
                      const newChoix = column.choix[0];
                      columnChoix.push(newChoix);
                    }
                  }
                });
              }
              const index = this.idsLoading.findIndex(x => x == id);
              if (index >= 0) {
                this.idsLoading.splice(index, 1);
              }
            })
          }
        }
        return copy
      }
    }
  }


  

  public get listClient (): Client[] {
    return this.reccords;
  }

  public get listConfigClient (): ColumnConfig[] {
    return this.config;
  }


  @Mutation
  private mClientRegistered (): void {
    this.dataRegistered = true;
  }

  @Mutation
  public mClientClearData (): void {
    this.reccords = [];
    this.idsLoading = [];
    this.dataLoading = false;
    this.dataLoaded = false;
    this.dataRegistered = false;
  }

  @Mutation
  private mClientLoading (value: boolean): void {
    this.dataLoading = value;
  }

  @Mutation
  private mClientLoaded (data: ListData): void {
    this.dataLoaded = true;
    this.idsLoading.splice(0, this.idsLoading.length);
    this.reccords = [];
    data.reccords.forEach((reccord) => {
      this.reccords.push(Client.fromJson(reccord as Client));
    })
    Client.getDate(this.reccords);
    this.config = data.config.columnsConfig;
  }

  @Mutation
  private mClientConfigUpdated (newConfig: ListConfig): void {
    newConfig.columnsConfig.forEach((column) => {
      if (column.choix.length == 1) {
        const columnConfig = this.config.find(a => a.name == column.name);
        if (columnConfig && !columnConfig.choix.find(a => a.value == column.choix[0].value)) {
          const columnChoix = columnConfig.choix;
          const newChoix = column.choix[0];
          columnChoix.push(newChoix);
          console.log(newChoix);
        }
      }
    });
  }

  @Mutation
  public mClientCreated (obj: Client): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      let api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareClient(obj)) {
          api.fromClient(obj);
        }
      } else {
        api = this.reccords.find(x => x.createId == obj.createId && obj.createId != null && obj.createId != '');
        if (api) {
          if (!api.compareClient(obj)) {
            api.fromClient(obj);
          } else if (api.id != obj.id ) {
            api.id = obj.id;
          }
        } else {
          this.reccords.push(obj);
        }
      }
    }
  }

  @Mutation
  public mClientUpdated (obj: Client): void {
    const index = this.idsLoading.findIndex(x => x == obj.id);
    if (index < 0) {
      const api = this.reccords.find(x => x.id == obj.id);
      if (api) {
        if (!api.compareClient(obj)) {
          api.fromClient(obj);
        }
      } else {
        this.reccords.push(obj);
      }
    }
  }

  @Mutation
  public mClientDeleted (id: number): void {
    const index = this.reccords.findIndex(x => x.id == id);
    if (index >= 0) {
      this.reccords.splice(index, 1);
    }
  }

    
  @Action
  public registerClient (filter: ListFilter | null = null): Promise<boolean> {
    return new Promise((resolve) => {
      if (!this.clientRegistered && storeSession.hubUsed) {
        if (HubServices.hubReady()) {
          HubServices.registerClient(this.clientCreated, this.clientUpdated, this.clientDeleted);
          this.mClientRegistered();
        } else {
          setTimeout(() => resolve(this.registerClient(filter)), 1000);
        }
      }
      if (filter != null) {
        if (HubServices.hubReady() && !this.clientLoading && !this.clientLoaded) {
          this.mClientLoading(true);
          return Client.list(filter)
            .then((data: ListData) => {
              this.mClientLoaded(data);
              this.mClientLoading(false);
              resolve(true);
            })
        }
      } else  {
        resolve(true);
      }
  })
}


  @Action
  public listFilteredClient (filter: ListFilter): Promise<boolean> {
    return new Promise((resolve) => {
      if (HubServices.hubReady() && !this.clientLoading) {
        this.mClientLoading(true);
        return Client.list(filter)
          .then((data: ListData) => {
            this.mClientLoaded(data);
            this.mClientLoading(false);
            resolve(true);
          })
      }
    })
  }


  
  @Action
  public createClient (obj: Client): Promise<Client> {
    return new Promise((resolve, reject) => {
      return Client.fromJson(obj).createForStoreClient()
        .then((reccords) => {
          this.mClientCreated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  public updateClient (obj: Client): Promise<Client> {
    return new Promise((resolve, reject) => {
      return Client.fromJson(obj).updateForStoreClient()
        .then((reccords) => {
          this.mClientUpdated(reccords);
          resolve(reccords);
        })
        .catch(() => {
          reject();
        });
    })
  }
  
  @Action
  public deleteClient (obj: Client): Promise<boolean> {
    return new Promise((resolve, reject) => {
      return Client.fromJson(obj).deleteForStoreClient()
        .then(() => {
          if (!storeSession.hubUsed) {
            this.mClientDeleted(obj.id);
          }
          resolve(true);
        })
        .catch(() => {
          reject();
        });
    })
  }

  
  @Action
  private clientCreated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mClientConfigUpdated(config)
    const obj = objConfig.obj as Client;
    this.mClientCreated(Client.fromJson(obj));
  }

  @Action
  private clientUpdated (objConfig: ListItem): void {
    const config = objConfig.config as ListConfig
    this.mClientConfigUpdated(config)
    const obj = objConfig.obj as Client;
    this.mClientUpdated(Client.fromJson(obj));
  }

  @Action
  private clientDeleted (objConfig: ListItem): void {
    const obj = objConfig.obj as Client;
    this.mClientDeleted(obj.id);
  }
}
